import React, { useState } from 'react';
import {
  Button, Container, Modal, ModalBody, ModalFooter, ModalHeader,
} from 'reactstrap';
import { useIntercom } from 'react-use-intercom';
import { Trans, useTranslation } from 'react-i18next';
import useDemoCampaign from '../utils/hooks/demoCampaign';
import { isValidObjectId } from '../utils/helpers';
import ExternalLink from './ExternalLink';
import useQueryParams from '../utils/hooks/queryParam.hook';

const { REACT_APP_ADMIN_URL } = process.env;

export const BuilderHeader = () => {
  const [translate] = useTranslation();
  const articlePackageId = useQueryParams('articlePackageId');
  const lang = useQueryParams('lang') || 'nl';
  const { show: showIntercom } = useIntercom();

  const [modalOpen, setModalOpen] = useState(true);
  const [firstOpen, setFirstOpen] = useState(true);

  const toggle = () => {
    setModalOpen((o) => !o);
    setFirstOpen(false);
  };

  const { loading, campaign: { articlePackage = undefined } = {} } = useDemoCampaign() || {};

  if (!loading && !isValidObjectId(articlePackageId)) {
    return (
      <Modal isOpen>
        <ModalHeader>Error</ModalHeader>
        <ModalBody>Invalid articlePackageId.</ModalBody>
      </Modal>
    );
  }

  return (
    <>
      <div className="header" style={{ background: 'rgba(94,114,228,0.7)', color: 'white' }}>
        <Container className="py-3 py-md-0 lh-lg">
          {translate('COMPONENTS.DEMO.HEADER')}
          {' '}
          <Button color="primary" onClick={toggle} className="my-2">
            {translate('COMPONENTS.DEMO.MORE_INFO')}
          </Button>
        </Container>
      </div>
      <Modal isOpen={modalOpen} toggle={toggle}>
        <ModalHeader toggle={toggle}>
          {translate('COMPONENTS.DEMO.DEMO_SALE')}
        </ModalHeader>
        <ModalBody>
          <>
            <Trans i18nKey="COMPONENTS.DEMO.DESCRIPTION" values={{ name: articlePackage?.name }}>
              <p>
                Welcome to the demo webshop of
                {' '}
                {articlePackage?.name}
                !
              </p>

              <p>
                This is what your organisations webshop could look like.
                You can make your own version
                {' '}
                <ExternalLink href={`${REACT_APP_ADMIN_URL}/new?articlePackageId=${articlePackage?._id}&lang=${lang}`}>
                  in a few clicks
                </ExternalLink>
                .
              </p>

              <p>
                For more information about this sale, such as purchase and sale prices:
                {' '}
                <a href={
                  `https://trooper.be${lang === 'nl' ? '/nl/webshop/aanbod' : '/fr/webshop/ventes'}/${articlePackage?.slug}`
                  }
                >
                  go back to the Trooper website
                </a>
                .
              </p>
            </Trans>

            {!firstOpen && (
            <p>
              <Trans i18nKey="COMPONENTS.DEMO.CHAT">
                Any questions?
                {' '}
                <Button onClick={() => showIntercom()} color="link" className="fw-light text-decoration-none p-0 align-baseline">
                  Contact us in the chat!
                </Button>
              </Trans>
            </p>
            )}
          </>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            Sluiten
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};
